import React from "react";
import styles from './LocationDate.module.scss'
import moment from 'moment';
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';

export interface ILocationTime {
  ticketDetails: ITicketDetailsWithTerms;
  fromDestination?: boolean;

}


const LocationDate = (props: ILocationTime) => {
  const timeOfLanding = props.fromDestination ? props.ticketDetails.destinationTimeOfLanding : props.ticketDetails.originTimeOfLanding;
  return (
    <div
      className={styles.locationDate}
    >
      <h5 className={styles.day}>{moment(timeOfLanding).format('D')}</h5>
      <h5 className={styles.month}>{moment(timeOfLanding).format('MMM').toUpperCase()}</h5>
      <h5 className={styles.year}>{moment(timeOfLanding).format('YYYY')}</h5>
    </div>
  )
};

LocationDate.defaultProps = {
  fromDestination: false,
  style: {},
};

export default LocationDate;
